import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import relaxedNextButtonSelector from '../../../selectors/idverification/idcard/RelaxedNextButtonSelector';

import CapturedPhotoCheckpointNavigationButton from '../capturedevice/CapturedPhotoCheckpointNavigationButton';
import NextButton from '../capturedevice/NextButton';

import styles from './idcard.scss';

class RelaxedNextButton extends React.PureComponent {
    static propTypes = {
        approved: PropTypes.bool.isRequired,
        nextAnywayMessage: PropTypes.string.isRequired,
        onNext: PropTypes.func.isRequired,
        showNextAnyway: PropTypes.bool.isRequired,
    };

    render() {
        const {
            approved,
            nextAnywayMessage,
            onNext,
            showNextAnyway,
        } = this.props;

        if (!showNextAnyway) {
            return (
                <CapturedPhotoCheckpointNavigationButton
                    approved={approved}
                    onNext={onNext}
                />
            );
        }

        return (
            <React.Fragment>
                <span className={styles.nextAnywayMessage}>
                    {nextAnywayMessage}
                </span>
                <NextButton onNext={onNext} />
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return relaxedNextButtonSelector.mapStateToProps(state, ownProps);
}

export default connect(mapStateToProps)(RelaxedNextButton);
